import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import ja from "./locales/ja.json";

const LANGUAGE_STORAGE_KEY = "aw-language";
const RESOURCES = {
  en: { root: en },
  es: { root: es },
  fr: { root: fr },
  ja: { root: ja },
} as const;
const SUPPORTED_LANGUAGE_CODES = new Set(Object.keys(RESOURCES));

function warnLanguageStorageUnavailable(
  operation: "read" | "write",
  error: unknown,
) {
  const errorName =
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    typeof error.name === "string"
      ? error.name
      : "UnknownError";

  console.warn("i18n.languageStorage.unavailable", {
    operation,
    errorName,
  });
}

function getInitialLanguage() {
  if (typeof window === "undefined") return "en";
  let cachedLanguage: string | null = null;
  try {
    cachedLanguage = window.localStorage?.getItem(LANGUAGE_STORAGE_KEY) ?? null;
  } catch (error) {
    warnLanguageStorageUnavailable("read", error);
  }
  return cachedLanguage && SUPPORTED_LANGUAGE_CODES.has(cachedLanguage)
    ? cachedLanguage
    : "en";
}

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  resources: RESOURCES,
  fallbackLng: "en",
  ns: ["root"],
  defaultNS: "root",
  nsSeparator: false,
  keySeparator: ".",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (language: string) => {
  if (typeof document !== "undefined") document.documentElement.lang = language;
  if (typeof window !== "undefined" && SUPPORTED_LANGUAGE_CODES.has(language)) {
    try {
      window.localStorage?.setItem(LANGUAGE_STORAGE_KEY, language);
    } catch (error) {
      warnLanguageStorageUnavailable("write", error);
    }
  }
});

export default i18n;
